// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3a7ak","title":"Header_title__Q2gnU","side":"Header_side__32h_O"};